import React, { useEffect, useState, useContext } from 'react'
import {
    CognitoIdentityProviderClient,
    ConfirmForgotPasswordCommand,
} from "@aws-sdk/client-cognito-identity-provider"
import CloudformationOutputs from '../CloudformationOutputs.json'
import { GlobalContext } from '../GlobalContext'
import { subscribe } from "../utils/pubsub"
import Spinner from "../ui-elements/Spinner"
import Button from '../formfields/Button'
import RedAlert from '../ui-elements/RedAlert'
import Modal from '../ui-elements/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import Password from './auth_formfields/Password'
import Text from './auth_formfields/Text'
import { isValidCognitoPassword } from '../utils/isValidCognitoPassword'

type Props = {
    setForgotPasswordEmail: React.Dispatch<React.SetStateAction<any>>
    forgotPasswordEmail: string
}


function ForgotPasswordCodeForm({
    setForgotPasswordEmail,
    forgotPasswordEmail
}: Props) {

    const {
        tableData,
        setShowModal,
        sendMessageToWebsocket,
        currentOrganisation,
        orgIdFromQrCode,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const [formFields, setFormFields] = useState<ObjectStringKeyAnyValue>({})
    const [formErrors, setFormErrors] = useState<ObjectStringKeyAnyValue>({})




    const validate = () => {
        let isValid = true
        let newFormErrors: ObjectStringKeyAnyValue = {}

        if (
            !formFields["passwordResetCode"]
        ) {
            isValid = false
            newFormErrors["passwordResetCode"] = t('Auth.ForgotPasswordCodeForm.pleaseEnterCode')
        }

        if (
            !formFields["newPassword"] ||
            !isValidCognitoPassword(formFields["newPassword"])
        ) {
            isValid = false
            newFormErrors["newPassword"] = t('Auth.ForgotPasswordCodeForm.pleaseEnterValidPassword')
        }

        if (
            formFields["newPassword"] !== formFields["newPasswordConfirm"]
        ) {
            isValid = false
            newFormErrors["newPasswordConfirm"] = t('Auth.ForgotPasswordCodeForm.passwordsMustMatch')
        }

        setFormErrors(newFormErrors)
        return isValid
    }




    const validateAndSave = () => {
        const isValid = validate()

        if (isValid) {
            setShowModal({ "spinner": t('Auth.ForgotPasswordCodeForm.sendingCode') })
            const client = new CognitoIdentityProviderClient({ region: CloudformationOutputs['AWSRegion'] })
            const username = forgotPasswordEmail.toLowerCase()
            const confirmationCode = formFields["passwordResetCode"]
            const newPassword = formFields["newPassword"]
            const command = new ConfirmForgotPasswordCommand({
                ClientId: CloudformationOutputs['UserPoolClientId'],
                Username: username,
                ConfirmationCode: confirmationCode,
                Password: newPassword,
            })
            client.send(command)
                .then((response: any) => {
                    setForgotPasswordEmail('')
                    setShowModal({ 'success': t('Auth.ForgotPasswordCodeForm.passwordResetSuccess') })
                    navigate('/login')
                })
                .catch((error: any) => {
                    setShowModal({ "error": t('Auth.ForgotPasswordCodeForm.passwordResetError') })
                    console.error("Error resetting password", error)
                })
        }
    }




    return <div className={`w-full flex flex-col gap-4`}>

        <h3 className={`font-righteous text-2xl text-brand-dark`}>
            {t('Auth.ForgotPasswordCodeForm.forgotYourPassword')}
        </h3>
        <p>{t('Auth.ForgotPasswordCodeForm.weHaveSentCode', { email: forgotPasswordEmail })}</p>
        <p>{t('Auth.ForgotPasswordCodeForm.pleaseCheckEmail')}</p>



        <Text
            labelText={t('Auth.ForgotPasswordCodeForm.passwordResetCode')}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'passwordResetCode'}
            size={'big'}
            center={true}
            required={true}
        />

        <Password
            labelText={t('Auth.ForgotPasswordCodeForm.newPassword')}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'newPassword'}
            size={'big'}
            center={true}
            required={true}
        />

        <Password
            labelText={t('Auth.ForgotPasswordCodeForm.confirmNewPassword')}
            formFields={formFields}
            formErrors={formErrors}
            setFormFields={setFormFields}
            fieldName={'newPasswordConfirm'}
            size={'big'}
            center={true}
            required={true}
        />



        <div className={`w-full flex flex-row gap-4`}>
            <Button
                onClick={() => {
                    setForgotPasswordEmail('')
                    navigate('/login')
                }}
                text={t('Buttons.cancel')}
                variant={'gray'}
                size={'big'}
                sameWindow={true}
            />
            <Button
                onClick={validateAndSave}
                text={t('Buttons.next')}
                variant={'secondary'}
                size={'big'}
                sameWindow={true}
            />
        </div>
    </div>
}
export default ForgotPasswordCodeForm